export function getTourStorageKey(pagePath: string, version: string): string {
    return `tour:${pagePath}:${version}`;
}

export function isTourSeen(pagePath: string, version: string): boolean {
    try {
        const key = getTourStorageKey(pagePath, version);

        return (
            typeof window !== 'undefined' && localStorage.getItem(key) === '1'
        );
    } catch {
        return false;
    }
}

export function markTourSeen(pagePath: string, version: string): void {
    try {
        const key = getTourStorageKey(pagePath, version);

        if (typeof window !== 'undefined') {
            localStorage.setItem(key, '1');
        }
    } catch {
        // noop: storage might be unavailable (SSR/private mode)
    }
}
